/**
 * Created by claudio iozzia on 04/05/2017.
 */
import {ValidatorFn, ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {Ic, IEntityAlert, ITranslatedObj} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {EntityError} from "../../../../models/EntityAlert";
import {Utils} from "../../../../common/utils";
import {IOutput, ISingleOutput} from "../../../../models/ISpec";
import {Flyback} from "../flyback";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";
import {Validator_Common} from "../../../../models/validator/validator_common";

export class Validator_AcDc_Flyback extends Validator_Common {
  private validatorFn_SingleOutput_Voltage_FlyBack_FirstOutput: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    let result: ITranslatedObj = null;
    if (o === 0) {
      const _vOut = spec.spec.value.output.outputs[o].voltage;
      if (_vOut < 0) {
        result = {
          key: 'first output must be positive'
        };
      }
    }
    return new EntityError(result);
  }


  private validatorFn_SingleOutput_Voltage_FlyBack: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vOut = spec.spec.value.output.outputs[o].voltage;
    const result = Utils.acceptGreaterThan(Math.abs(_vOut), a.vout_min, "Vout", "V");
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Current_FlyBack: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _iOut = spec.spec.value.output.outputs[o].current;
    const powerOutUpperBound: number = this.calculate_PowerOutUpperBound(a, spec);
    const powerOutRequired: number = this.requiredPowerOut(a, spec.spec.value.output);

    // potenza residua ancora spendibile
    const powerOutStillAvailable: number = powerOutUpperBound - powerOutRequired;
    // la utilizzeremo per calcolare il limite massimo di corrente per ogni uscita

    const currentUpperBound: number = this.calculate_currentUpperBound(a, spec.spec.value.output.outputs[o], powerOutStillAvailable);
    const result = Utils.acceptUpTo(_iOut, currentUpperBound, "Iout", "A");
    return new EntityError(result);
  }

  private calculate_currentUpperBound(ic: Ic, out: ISingleOutput<number>, powerOutStillAvailable: number): number {
    const voltage: number = Utils.isValueEmpty(out.voltage)
      ? ic.vout_min
      : Math.abs(out.voltage);

    const power: number = Utils.Value(out.power);
    const powerUpperBound: number = Math.max(0, power + powerOutStillAvailable);
    return ValueFormatter.scale((powerUpperBound / voltage), siPrefix.unit, 2, 'f');
  }

  private requiredPowerOut(ic: Ic, output: IOutput<number>): number {
    return output.outputs.reduce((acc: number, out: ISingleOutput<number>) => {
      return acc + Utils.Value(out.power);
    }, 0);
  }

  private calculate_PowerOutUpperBound(a: Ic, spec: IAppSpec): number {
    const vinMin_dc = spec.spec.value.input.min * Math.SQRT2;
    const vinMax_dc = spec.spec.value.input.max * Math.SQRT2;

    return Utils.getFieldValue(a, spec.spec.value.input.min < 150
      ? "validator.power.maxWide"     // max1
      : "validator.power.maxEurope") // max2
      || Flyback.maxLimPower(a, vinMin_dc);
  }

  private validatorFn_Pout_FlyBack: ValidatorFn = (a: Ic, spec: IAppSpec) => {
    const powerOutUpperBound: number = this.calculate_PowerOutUpperBound(a, spec);
    const powerOutRequired: number = this.requiredPowerOut(a, spec.spec.value.output);

    const result = Utils.acceptUpTo(powerOutRequired, powerOutUpperBound, "PLoad", "W");
    return new EntityError(result);
  }


  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_FlyBack_FirstOutput, this.validatorFn_SingleOutput_Voltage_FlyBack].concat(super.singleOutputV());
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_FlyBack].concat(super.singleOutputI());
  }

  protected globalOutputP(): ValidatorFn[] {
    return [this.validatorFn_Pout_FlyBack].concat(super.globalOutputP());
  }
}
